/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlGetListBadges = "/badge/list";
const urlUpdateBadge = "/badge/update";

const state = {
  badges: [],
  totalRecords: 0,
  totalPages: 1,
  currentPage: 1,
};

const actions = {
  /**
   * Get List badges
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListBadges({ commit }, query) {
    try {
      const response = await axios.get(
        urlGetListBadges + "?" + new URLSearchParams(query),
      );
      if (response.data.status_code === 200) {
        commit("SET_LIST_BADGES", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * Update Badge
   * @param commit
   * @param payload
   * @returns {Promise<*>}
   */
  async updateBadge({ commit }, payload) {
    return await axios.post(urlUpdateBadge, payload);
  },

  /**
   * setCurrentPage
   * @param commit
   * @param currentPage
   */
  setCurrentPage({ commit }, currentPage) {
    commit("SET_CURRENT_PAGE", currentPage);
  },
};

const mutations = {
  SET_LIST_BADGES(state, data) {
    state.badges = data.data;
    state.totalRecords = data.total_records;
    state.totalPages = data.total_pages;
  },
  SET_CURRENT_PAGE(state, currentPage) {
    state.currentPage = currentPage;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
